import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { FileText, Download, ChevronLeft, ChevronRight } from 'lucide-react';

const ReportExamples = () => {
  const scrollRef = useRef(null);

  const reports = [
    { title: "Audit Web SaaS", info: "Janvier 2024 • 42 pages", color: "bg-red-50", iconColor: "text-red-500" },
    { title: "Audit Réseau Banque", info: "Mars 2024 • 68 pages", color: "bg-blue-50", iconColor: "text-blue-500" },
    { title: "Infra Interne E-com", info: "Février 2024 • 35 pages", color: "bg-emerald-50", iconColor: "text-emerald-500" },
    { title: "Template Synthétique", info: "Modèle type • 12 pages", color: "bg-purple-50", iconColor: "text-purple-500" },
    { title: "Audit Cloud AWS", info: "Avril 2024 • 55 pages", color: "bg-orange-50", iconColor: "text-orange-500" },
    { title: "Pentest API Mobile", info: "Mai 2024 • 29 pages", color: "bg-cyan-50", iconColor: "text-cyan-500" }
  ];

  const scroll = (dir) => {
    const { current } = scrollRef;
    const scrollAmount = 280; // Taille d'une carte + gap
    current.scrollBy({ left: dir === 'l' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  };

  return (
    <section className="w-full bg-white py-16 px-6 overflow-hidden font-inter">
      <div className="max-w-[1050px] mx-auto">
        
        {/* HEADER EQUILIBRÉ */}
        <div className="flex items-end justify-between mb-10">
          <div className="space-y-1">
            <h2 className="text-[#0f172a] text-[28px] font-[900] tracking-tight">Exemples de rapports</h2>
            <p className="text-slate-500 text-[14px] font-medium opacity-90">La précision de nos livrables en un coup d'œil.</p>
          </div>

          <div className="flex gap-3">
            <button 
              onClick={() => scroll('l')} 
              className="p-2.5 border border-slate-200 rounded-full hover:bg-slate-50 text-slate-400 hover:text-[#3b82f6] transition-all"
            >
              <ChevronLeft size={20}/>
            </button>
            <button 
              onClick={() => scroll('r')} 
              className="p-2.5 bg-[#3b82f6] rounded-full text-white hover:bg-blue-600 shadow-md shadow-blue-500/20 transition-all"
            >
              <ChevronRight size={20}/>
            </button>
          </div>
        </div>

        {/* SLIDER MEDIUM */}
        <div 
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-8 cursor-grab active:cursor-grabbing"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {reports.map((r, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -6 }}
              className="min-w-[260px] bg-[#F8FAFC] border border-slate-100 p-6 rounded-[1.5rem] flex flex-col shadow-sm transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/5"
            >
              <div className={`w-11 h-11 ${r.color} rounded-xl flex items-center justify-center mb-6`}>
                <FileText size={18} className={r.iconColor} />
              </div>

              <h3 className="text-[#0f172a] text-[15px] font-black mb-1.5">{r.title}</h3>
              <p className="text-slate-400 text-[12px] font-medium mb-8">{r.info}</p>

              <button className="mt-auto w-full py-3 border-2 border-[#3b82f6] rounded-xl flex items-center justify-center gap-2 text-[#3b82f6] text-[12px] font-black hover:bg-[#3b82f6] hover:text-white transition-all">
                <Download size={14} /> Télécharger PDF
              </button>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ReportExamples;